<template>
  <div id="home">
    <div class="app-header">
      <div class="app-header-nav-wrapper">
        <div class="app-header-nav">
          <img class="app-header-logo" src="../assets/logo.png" width="100" />
          <div
            style="
              padding: 5px 10px;
              font-size: 12px;
              position: absolute;
              right: 20px;
              top: 17px;
            "
            class="app-header-button app-button plain"
            @click="goRouter('shandian')"
          >
            了解闪店
          </div>
          <div class="layout-aic app-header-nav-box">
            <ul class="app-header-nav-list">
              <li
                v-for="item in navList"
                :key="item.name"
                :class="{ active: item.name == activeNav }"
                @click="goRefs(item.name)"
                class="app-header-nav-item"
              >
                {{ item.text }}
              </li>
            </ul>
            <!-- <div class="app-button serve" @click="goRefs('serve')">
              签证信息发布服务
              </div> -->
            <div class="app-button" @click="goRefs('contact')">立即体验</div>
          </div>
        </div>
      </div>
    </div>
    <swiper :options="swiperOption" ref="homeSwiper">
      <swiper-slide class="swiper-item">
        <div class="home-banner-wrapper" ref="index">
          <div class="home-banner">
            <div class="home-banner-item">
              <div class="home-banner1">
                <div class="home-banner1-content">
                  <h1>闪电签 签证更快一步！</h1>
                  <p>面向签证商家和旅行社</p>
                  <p>极速办理各国签证的Saas平台</p>
                  <div
                    style="width: 160px"
                    class="app-button app-button--blue"
                    @click="goRefs('contact')"
                  >
                    立即使用
                  </div>
                </div>
                <img
                  class="home-banner1-pic"
                  src="../assets/world_map@3x.png"
                  height="500"
                  alt="闪电签 签证更快一步！"
                />
              </div>
            </div>
            <div class="home-banner-mobile">
              <img
                src="../assets/banner@3x.jpg"
                width="100%"
                alt="闪电签 签证更快一步！"
              />
              <div class="app-button app-button--blue" @click="goRefs('contact')">
                立即体验
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- <swiper-slide class="swiper-item">
        <div
          class="home-banner-wrapper home-banner-wrapper--shandian"
          ref="shandian"
        >
          <div class="home-banner">
            <div class="home-banner-item">
              <div class="home-banner1">
                <div class="home-banner1-content">
                  <h1>
                    闪店
                    <br />旅行社自己的微商城
                  </h1>
                  <p>——专业的旅游业移动互联网解决方案提供商</p>
                  <div class="banner-button" @click="goRouter('shandian')">
                    立即咨询
                  </div>
                </div>
                <img
                  class="home-banner1-pic"
                  src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/phone.png"
                  alt="闪店，旅行社自己的微商城！"
                />
              </div>
          </div>
            <div class="home-banner-mobile">
              <img
                src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/banner2.jpg"
                width="100%"
                alt="闪店，旅行社自己的微商城"
              />
              <div
                style="bottom: 31%; left: 28%; opacity: 0"
                class="app-button app-button--blue"
                @click="goRouter('shandian')"
              >
                立即咨询
              </div>
            </div>
          </div>
        </div>
      </swiper-slide> -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="home-arrow-line home-arrow-line--banner">
      <span class="home-arrow-line-left"></span>
      <span class="home-arrow-line-right"></span>
    </div>
    <div class="home-main">
      <div class="home-main-item" ref="intro">
        <div class="home-intro">
          <h1 class="home-intro-title">全自动化签证操作</h1>
          <p class="home-content">信息扫描录入，无需人工手动录入</p>
          <p class="home-content">材料一键生成，出签进度实时跟进</p>
          <p class="home-content">新人5分钟培训即可上岗</p>
          <div class="home-intro-icon">
            <div class="home-intro-icon-item">
              <img src="../assets/intro-icon1@3x.png" alt="扫描录入" />
              <p>扫描录入</p>
            </div>
            <div class="home-intro-icon-item">
              <img src="../assets/intro-icon2@3x.png" alt="扫描录入" />
              <p>实时跟进</p>
            </div>
            <div class="home-intro-icon-item">
              <img src="../assets/intro-icon3@3x.png" alt="扫描录入" />
              <p>快速掌握</p>
            </div>
          </div>
        </div>
        <div class="home-pic">
          <img width="475" src="../assets/intro-pic1@3x.jpg" alt="全自动化签证操作" />
        </div>
        <div class="home-content-h5-wrap">
          <p class="home-content">信息扫描录入，无需人工手动录入</p>
          <p class="home-content">材料一键生成，出签进度实时跟进</p>
          <p class="home-content">新人5分钟培训即可上岗</p>
        </div>
      </div>

      <div class="home-main-item clearfix right">
        <div class="home-intro left">
          <h1 class="home-intro-title">办理效率极速提升</h1>
          <p class="home-content">免注册邮箱，免填表</p>
          <p class="home-content">原有30分钟一本马来西亚签证，现在仅需5分钟</p>
          <p class="home-content">原有60分钟一本DS160填表，现在仅需10分钟</p>
          <div class="home-intro-icon">
            <div class="home-intro-icon-item">
              <img src="../assets/intro-icon4@3x.png" alt="效率极速" />
              <p>效率极速</p>
            </div>
            <div class="home-intro-icon-item">
              <img src="../assets/intro-icon5@3x.png" alt="省时省力" />
              <p>省时省力</p>
            </div>
          </div>
        </div>
        <div class="home-pic">
          <img width="475" src="../assets/intro-pic2@3x.jpg" alt="办理效率极速提升" />
        </div>
        <div class="home-content-h5-wrap">
          <p class="home-content">免注册邮箱，免填表</p>
          <p class="home-content">原有30分钟一本马来西亚签证，现在仅需5分钟</p>
          <p class="home-content">原有60分钟一本DS160填表，现在仅需10分钟</p>
        </div>
      </div>

      <div class="home-main-item">
        <div class="home-intro">
          <h1 class="home-intro-title">收单小程序 量身定制</h1>
          <p class="home-content">随时随地收单，订单实时智能流转</p>
          <p class="home-content">小程序上传资料，实时同步闪电签系统</p>
          <p class="home-content">不管是直客还是同业，通通适用</p>
          <div class="home-intro-icon">
            <div class="home-intro-icon-item">
              <img src="../assets/intro-icon6@3x.png" alt="效率极速" />
              <p>小程序</p>
            </div>
            <div class="home-intro-icon-item">
              <img src="../assets/intro-icon7@3x.png" alt="省时省力" />
              <p>实时同步</p>
            </div>
          </div>
        </div>
        <div class="home-pic">
          <img width="475" src="../assets/intro-pic3@3x.jpg" alt="收单小程序 量身定制" />
        </div>
        <div class="home-content-h5-wrap">
          <p class="home-content">随时随地收单，订单实时智能流转</p>
          <p class="home-content">小程序上传资料，实时同步闪电签系统</p>
          <p class="home-content">不管是直客还是同业，通通适用</p>
        </div>
      </div>
      <div class="home-arrow-line" style="margin-top: 65px">
        <span class="home-arrow-line-left"></span>
        <span class="home-arrow-line-right"></span>
      </div>
      <div class="home-feature-wrapper">
        <div class="home-feature">
          <h1 class="home-feature-main-title h5">主要功能</h1>
          <div class="home-feature-background"></div>
          <div class="home-feature-content">
            <span class="semi-circle semi-circle-start"></span>
            <span class="semi-circle semi-circle-end"></span>
            <h1 class="home-feature-main-title">主要功能</h1>
            <div class="home-feature-list clearfix">
              <div class="home-feature-item">
                <img
                  src="../assets/feature-icon1@3x.png"
                  alt="智能操作"
                  class="home-feature-icon"
                />
                <h1 class="home-feature-title">智能操作</h1>
                <p class="home-content">OCR扫描，精准识别</p>
                <p class="home-content">签证资料智能填表，表格一键生成</p>
                <p class="home-content">批量处理，上百份签证同步操作，省时省力</p>
                <span class="semi-circle semi-circle-start"></span>
                <span class="semi-circle semi-circle-end"></span>
              </div>
              <div class="home-feature-item">
                <img
                  src="../assets/feature-icon2@3x.png"
                  alt="免费工具"
                  class="home-feature-icon"
                />
                <h1 class="home-feature-title">免费工具</h1>
                <p class="home-content">在职证明、邀请函、出资证明</p>
                <p class="home-content">翻译小工具，可在线翻译户口簿，身份证</p>
                <span class="semi-circle semi-circle-start"></span>
                <span class="semi-circle semi-circle-end"></span>
              </div>
              <div class="home-feature-item">
                <img
                  src="../assets/feature-icon3@3x.png"
                  alt="收单系统"
                  class="home-feature-icon"
                />
                <h1 class="home-feature-title">收单系统</h1>
                <p class="home-content">客户填写资料自动上传系统</p>
                <p class="home-content">操作人员实时收单检查</p>
                <p class="home-content">直客订单，同业订单，通通适用</p>
                <span class="semi-circle semi-circle-start"></span>
                <span class="semi-circle semi-circle-end"></span>
              </div>
              <div class="home-feature-item">
                <img
                  src="../assets/feature-icon4@3x.png"
                  alt="快速响应"
                  class="home-feature-icon"
                />
                <h1 class="home-feature-title">快速响应</h1>
                <p class="home-content">领馆新政可在1-2个小时内快速响应</p>
                <p class="home-content">
                  操作人员5分钟即可掌握系统操作，省时省力，快速上手
                </p>
                <span class="semi-circle semi-circle-start"></span>
                <span class="semi-circle semi-circle-end"></span>
              </div>
              <div class="home-feature-item">
                <img
                  src="../assets/feature-icon5@3x.png"
                  alt="周边服务"
                  class="home-feature-icon"
                />
                <h1 class="home-feature-title">周边服务</h1>
                <p class="home-content">一键生成结婚证/在职证明/户口本翻译件</p>
                <p class="home-content">在线办理保证金冻结/存款证明/个税证明</p>
                <span class="semi-circle semi-circle-start"></span>
                <span class="semi-circle semi-circle-end"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home-partner-wrapper">
        <div class="home-partner" ref="partner">
          <div class="home-partner-title">合作伙伴</div>
          <p class="home-partner-sub-title">顺丰快递 · 浦发银行</p>
          <ul class="home-partner-list">
            <!-- <li class="home-partner-item">
              <img src="../assets/partner-logo1@3x.png" alt="飞猪">
              <p>飞猪</p>
            </li>
            <li class="home-partner-item">
              <img src="../assets/partner-logo2@3x.png" alt="携程旅游">
              <p>携程旅游</p>
            </li>
            <li class="home-partner-item">
              <img src="../assets/partner-logo3@3x.png" alt="马蜂窝">
              <p>马蜂窝</p>
            </li>-->
            <li class="home-partner-item">
              <img src="../assets/partner-logo4@3x.png" alt="顺丰快递" />
              <p>顺丰快递</p>
            </li>
            <li class="home-partner-item">
              <img src="../assets/partner-logo5@3x.png" alt="浦发银行" />
              <p>浦发银行</p>
            </li>
          </ul>
          <div class="home-partner-img">
            <img src="../assets/platform@3x.png" alt />
          </div>
        </div>
      </div>
      <div class="home-contact-wrapper">
        <div class="home-contact" ref="contact">
          <div class="home-contact-title">自动化签证工具，提高工作效率</div>
          <div class="home-contact-content">
          
            <div class="home-contact-item home-contact-item--left">
              <div class="home-contact-item home-contact-item--left-p1">立即体验产品</div>
              <div class="home-contact-item home-contact-item--left-p2">注册账号 -> 登录系统 -> 开始使用</div>
              <div class="app-button" style="padding:9px 25px;font-size:16px" @click="goToVisaHome">开始试用</div>
              <!-- <p class="error-text">{{ errorText }}</p>
              <div class="home-contact-form">
                <div class="app-form-item">
                  <input
                    v-model="teamName"
                    placeholder="公司名称"
                    type="text"
                  />
                </div>
                <div
                  class="app-form-item app-form-item--select city-select-form-item"
                  @click.stop="show_city_select = true"
                >
                  <input
                    style="pointer-events: none"
                    :value="cityValue"
                    placeholder="所在城市"
                    type="text"
                  />
                  <div class="city-select" v-show="show_city_select">
                    <ul class="city-select-list province">
                      <li
                        class="city-select-item"
                        :class="{ active: currentProvinceName == item.name }"
                        v-for="item in province"
                        :key="item.id"
                        @click.stop="
                          ;(currentProvinceName = item.name),
                            (currentCityName = '')
                        "
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                    <ul class="city-select-list city" v-if="citys.length">
                      <li
                        class="city-select-item"
                        :class="{ active: currentCityName == item.name }"
                        v-for="item in citys"
                        :key="item.id"
                        @click.stop="
                          ;(currentCityName = item.name),
                            (show_city_select = false)
                        "
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="app-form-item">
                  <input
                    v-model="contacts"
                    placeholder="联系人姓名"
                    type="text"
                  />
                </div>
                <div class="app-form-item">
                  <input
                    v-model="mobile"
                    placeholder="联系人手机号"
                    type="tel"
                  />
                </div>
              </div>
              <div class="layout-jcfe home-contact-form-submit-button">
                <div style="width: 160px" class="app-button" @click="submit">
                  {{ confirmText }}
                </div>
              </div> -->
            </div>
            <div class="home-contact-item home-contact-item--right">
              <h1>或者，直接联系我们</h1>
              <h2>拨打电话：0571-87670963</h2>
              <div class="home-contact-qr">
                <img width="162" src="../assets/qr.png" alt="联系我们" />
                <p>扫二维码与我们联系</p>
                <h2 class="dn">
                  <a href="tel:0571-87670963">拨打电话：0571-87670963</a>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="app-footer">
      <!-- 浙ICP备18013335号-1 ©2018 浙江保牛信息科技有限公司 -->
      <a
        style="color: rgba(0, 0, 0, 0.38)"
        href="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/images/business-license.jpg"
        target="_blank"
        >ICP证号：浙B2-20190812</a
      >
      &nbsp; ©{{ year }} 浙江保牛信息科技有限公司 &nbsp;
      <a
        style="color: rgba(0, 0, 0, 0.38)"
        href="https://beian.miit.gov.cn/"
        target="_blank"
        >浙ICP备18013335号-1</a
      >
      &nbsp;
      <a
        style="color: rgba(0, 0, 0, 0.38)"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602010617"
        target="_blank"
      >
        <img
          src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/images/beian.png"
          width="20"
        />
        &nbsp;
        <span>浙公网安备 33010602010617号</span>
      </a>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
import province from "@/data/province";
import axios from "axios";
export default {
  name: "home",
  data() {
    const year = new Date().getFullYear();
    return {
      year,
      swiperOption: {
        autoplay: false,
        loop: false,
        disableOnInteraction: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      province: province,
      currentProvinceName: "",
      currentCityName: "",
      teamName: "",
      contacts: "",
      mobile: "",
      errorText: "",
      show_city_select: false,
      scrollEnding: true,
      indexTop: 0,
      introTop: "",
      partnerTop: "",
      contactTop: "",
      interval: 0,
      confirmText: "提交",
      activeNav: "index",
      navList: [
        {
          text: "首页",
          name: "index",
        },
        {
          text: "产品说明",
          name: "intro",
        },
        {
          text: "商家合作",
          name: "partner",
        },
        {
          text: "联系我们",
          name: "contact",
        },
        // {
        //   text: '闪店',
        //   name: 'shandian',
        // },
        // {
        //   text: "保险",
        //   name: "baoxian"
        // },
      ],
    };
  },
  computed: {
    cityValue() {
      if (!this.currentProvinceName && !this.currentCityName) {
        return "";
      } else {
        return this.currentProvinceName + " / " + this.currentCityName;
      }
    },
    citys() {
      let province = this.province.filter(
        (item) => item.name == this.currentProvinceName
      );
      if (province.length) {
        return province[0].children;
      }
      return [];
    },
  },
  mounted() {
    document.addEventListener("click", () => {
      this.show_city_select = false;
    });
    window.requestAnimationFrame =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame;
    this.$nextTick(() => {
      document.addEventListener(
        "scroll",
        () => {
          this.setRefsScrollTop();
          let scrollTop = this.getScrollTop();
          if (scrollTop > this.introTop - 10 && scrollTop < this.partnerTop - 10) {
            this.activeNav = "intro";
          } else if (
            scrollTop > this.partnerTop - 10 &&
            scrollTop < this.contactTop - 10
          ) {
            this.activeNav = "partner";
          } else if (scrollTop > this.contactTop - 10) {
            this.activeNav = "contact";
          } else if (scrollTop >= 0 && scrollTop < 10) {
            this.activeNav = "index";
          }
        },
        false
      );
    });
  },
  methods: {
    goToVisaHome() {
      window.open('https://b.visaai.com/')
    },
    goRouter(name) {
      this.$router.push({
        name: name,
      });
    },
    getScrollTop() {
      return document.documentElement.scrollTop || document.body.scrollTop;
    },
    getClientHeight() {
      return document.documentElement.clientHeight || document.body.clientHeight;
    },
    getScrollHeight() {
      return document.documentElement.scrollHeight || document.body.scrollHeight;
    },
    setRefsScrollTop() {
      this.introTop = Math.floor(
        this.$refs.intro.getBoundingClientRect().top + this.getScrollTop() - 74
      );
      this.partnerTop = Math.floor(
        this.$refs.partner.getBoundingClientRect().top + this.getScrollTop() - 74
      );
      this.contactTop = Math.floor(
        this.$refs.contact.getBoundingClientRect().top + this.getScrollTop() - 74
      );
    },
    scrollHandle(top) {
      if (!this.scrollEnding) return;
      if (top - this.getScrollTop() > 0) {
        this.scrollEnding = false;
        this.scrollAnim(top, "plus");
      } else if (top - this.getScrollTop() < 0) {
        this.scrollEnding = false;
        this.scrollAnim(top, "minus");
      }
    },
    scrollAnim(top, type) {
      if (type == "plus" && top - this.getScrollTop() > 0) {
        if (top - this.getScrollTop() < 1) {
          this.scrollEnding = true;
          return;
        }
        requestAnimationFrame(() => {
          if (this.getScrollTop() + this.getClientHeight() > this.getScrollHeight() - 1) {
            this.scrollEnding = true;
            return;
          }
          let diff = Math.floor((top - this.getScrollTop()) / 6);
          if (diff < 1) {
            console.log(this.getScrollTop());
            window.scrollTo(0, this.getScrollTop() + 1);
            console.log(this.getScrollTop());
            this.scrollAnim(top, type);
          } else {
            // console.log(this.getScrollTop())
            window.scrollTo(0, this.getScrollTop() + diff);
            // console.log(this.getScrollTop())
            this.scrollAnim(top, type);
          }
        });
      } else if (type == "minus" && top - this.getScrollTop() < 0) {
        if (top - this.getScrollTop() > -1) {
          this.scrollEnding = true;
          return;
        }
        requestAnimationFrame(() => {
          let diff = (top - this.getScrollTop()) / 8;
          if (diff > -1) {
            window.scrollTo(0, this.getScrollTop() - 1);
            this.scrollAnim(top, type);
          } else {
            window.scrollTo(0, this.getScrollTop() + diff);
            this.scrollAnim(top, type);
          }
        });
      } else {
        this.scrollEnding = true;
        this.interval = 0;
      }
    },
    goRefs(name) {
      if (name == "serve") {
        window.open('https://fuwu.visaai.com ')
        return;
      }
      if (name == "shandian") {
        this.$router.push({
          name: "shandian",
        });
        return;
      }
      if (name == "baoxian") {
        location.href = "../baoxian/index.html";
        return;
      }
      this.setRefsScrollTop();
      this.scrollHandle(this[`${name}Top`]);
    },
    submit() {
      const teamNameReg = /^[\w\W]{2,64}$/;
      const nameReg = /^[\w\W]{1,30}$/;
      const phoneReg = /^(\+86([\s-])?)?1\d{10}$/;

      this.teamName = this.escapeHTML(this.teamName);
      this.contacts = this.escapeHTML(this.contacts);
      this.mobile = this.escapeHTML(this.mobile);

      if (!this.teamName) {
        this.errorText = "请输入公司名称";
        return;
      }
      if (!teamNameReg.test(this.teamName)) {
        this.errorText = "公司名称请输入2-64位的任意字符";
      }

      if (this.currentProvinceName === "" || this.currentCityName === "") {
        this.errorText = "请选择城市";
        return;
      }

      if (!this.contacts) {
        this.errorText = "请输入联系人姓名";
        return;
      }
      if (!nameReg.test(this.contacts)) {
        this.errorText = "联系人姓名请输入1-30位的任意字符";
        return;
      }

      if (!this.mobile) {
        this.errorText = "请输入手机号";
        return;
      }
      if (!phoneReg.test(this.mobile)) {
        this.errorText = "请输入格式正确的手机号";
        return;
      }

      this.errorText = "";
      this.confirmText = "正在提交...";
      const params = {
        city: this.currentCityName,
        contacts: this.contacts,
        mobile: this.mobile,
        province: this.currentProvinceName,
        teamName: this.teamName,
      };

      axios({
        method: "post",
        url: "https://visasapi.visaai.com/homepage/apply/submit",
        headers: {
          "Content-Type": "application/json",
        },
        data: params,
      })
        .then((response) => {
          // handle success
          this.confirmText = "提交";
          if (response.data.code === 0) {
            this.$message({
              text: "您的信息已经提交成功",
              type: "success",
              time: 5000,
            });
            this.currentCityName = "";
            this.contacts = "";
            this.mobile = "";
            this.currentProvinceName = "";
            this.teamName = "";
          } else {
            this.$message({
              text: response.data.msg,
              type: "error",
            });
          }
        })
        .catch((error) => {
          // handle error
          this.$message({
            text: "请求提交接口失败",
            type: "error",
          });
          this.confirmText = "提交";
          console.log(error);
        });
    },
    escapeHTML(text) {
      return text.replace(/[<>"&]/g, function (match, pos, originalText) {
        switch (match) {
          case "<":
            return "&lt;";
          case ">":
            return "&gt;";
          case "&":
            return "&amp;";
          case '"':
            return "&quot;";
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "../scss/variables";
@import "../scss/reset";
#home {
.serve{
  padding: 8px 19px !important;
  border: 1px solid #55bc97;
  background: none !important;
  color: #55bc97;
  margin-right: 15px;
}
  .swiper-pagination {
    bottom: 30px;
    .swiper-pagination-bullet {
      background-color: #fff;
      opacity: 1;
      margin: 0 8px;
    }
    .swiper-pagination-bullet-active {
      background-color: $themeColor;
    }
  }
  .app-header {
    box-shadow: 2px 2px 4px rgba(152, 152, 152, 0.22);
    background: #fff;
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    right: 0;
    height: 74px;
  }
  .app-header-nav {
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
    height: 74px;
    justify-content: space-between;
    align-items: center;
  }
  .app-header-button {
    display: none;
  }
  .app-header-banner {
    margin-top: 74px;
  }
  .app-header-nav-list {
    display: flex;
  }
  .app-header-nav-item {
    padding: 0 15px;
    line-height: 20px;
    position: relative;
    cursor: pointer;
    color: $font-color-primary;
    transition: ease all 0.3s;
    &:hover {
      color: $green;
    }
    &.active {
      color: $green;
      &:after {
        content: "";
        position: absolute;
        bottom: -7px;
        left: 13px;
        right: 13px;
        height: 4px;
        background-color: $green;
      }
    }
  }
  .home-banner-wrapper {
    margin-top: 74px;
    background-image: linear-gradient(90deg, #d8ffe5 26%, #a4dffd 100%);
    &--shandian {
      background: url("https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/banner-bg%403x.jpg?x-oss-process=image/resize,w_1920")
        no-repeat center center;
      background-size: cover;
      .home-banner1 {
        h1 {
          font-size: 46px;
          font-weight: normal;
          color: #fff;
          padding-bottom: 23px;
        }
        p {
          color: rgba(255, 255, 255, 0.8);
          font-size: 22px;
          font-weight: 300;
          line-height: 35px;
        }
        .banner-button {
          cursor: pointer;
          font-size: 18px;
          margin-top: 43px;
          border: 1px solid #fff;
          border-radius: 20px;
          padding: 7px 44px;
          color: #fff;
          display: inline-block;
        }
      }
      .home-banner1-content {
        position: relative;
        z-index: 2;
      }
      .home-banner1-pic {
        position: absolute;
        top: auto;
        right: 0;
        bottom: 0;
        width: 315px;
      }
    }
  }
  .home-banner {
    max-width: 1000px;
    margin: 0 auto;
    height: 534px;
    overflow: hidden;
  }
  .home-banner-item {
    height: 534px;
    display: flex;
    align-items: center;
    position: relative;
  }
  .home-banner-mobile {
    display: none;
  }
  .home-banner1 {
    h1 {
      font-size: 46px;
      font-weight: normal;
      color: $font-color-primary;
      padding-bottom: 23px;
    }
    p {
      font-size: 22px;
      line-height: 35px;
    }
    .app-button {
      margin-top: 80px;
    }
  }
  .home-banner1-content {
    position: relative;
    z-index: 2;
  }
  .home-banner1-pic {
    position: absolute;
    right: 0;
    top: 0;
  }
  .home-main-item {
    max-width: 1000px;
    margin: 0 auto;
    position: relative;
    padding-bottom: 46px;
    padding-top: 42px;
    &.right {
      .home-pic {
        float: right;
      }
    }
  }
  .home-intro {
    position: absolute;
    left: 590px;
    top: 62px;
    &.left {
      left: auto;
      right: 590px;
    }
  }
  .home-intro-title {
    font-size: 32px;
    line-height: 45px;
    font-weight: 500;
    padding-bottom: 20px;
    color: $font-color-primary;
  }
  .home-content-h5-wrap {
    display: none;
  }
  .home-content {
    line-height: 20px;
    padding-top: 10px;
    position: relative;
    padding-left: 16px;
    &:after {
      content: "";
      height: 2px;
      width: 6px;
      background-color: $green;
      position: absolute;
      left: 0;
      top: 18px;
    }
  }
  .home-intro-icon {
    display: flex;
    align-items: center;
    margin-top: 30px;
  }
  .home-intro-icon-item {
    position: relative;
    text-align: center;
    p {
      font-size: 12px;
    }
    img {
      display: block;
      width: 34px;
      height: 34px;
      margin-bottom: 6.5px;
      margin-left: 21px;
      margin-right: 21px;
    }
    &:after {
      content: "";
      position: absolute;
      top: 4px;
      height: 28px;
      right: 0;
      border-left: 1px solid rgba(0, 0, 0, 0.12);
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
  }
  .home-arrow-line {
    height: 0px;
    width: 100%;
    background-color: #fff;
    position: relative;
    z-index: 2;
    &--banner {
      background-color: transparent;
      .home-arrow-line-left,
      .home-arrow-line-right {
        border-color: #ffffff #ffffff #ffffff;
      }
      .home-arrow-line-left {
        border-right-color: transparent;
      }
      .home-arrow-line-right {
        border-left-color: transparent;
      }
    }
  }
  .home-arrow-line-left {
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 50%;
    height: 0px;
    box-sizing: border-box;
    border-width: 0 25px 25px 25px;
    border-style: none solid solid solid;
    border-color: #cbf3f5 #cbf3f5 #cbf3f5;
    border-right-color: transparent;
  }
  .home-arrow-line-right {
    position: absolute;
    right: 0px;
    bottom: 0px;
    width: 50%;
    height: 0px;
    box-sizing: border-box;
    border-width: 0 25px 25px 25px;
    border-style: none solid solid solid;
    border-color: #cbf3f5 #cbf3f5 #cbf3f5;
    border-left-color: transparent;
  }
  .home-feature-wrapper {
    display: flex;
    justify-content: center;
    background-color: #cbf3f5;
    padding-top: 30px;
    padding-bottom: 60px;
  }
  .home-feature {
    position: relative;
  }
  .home-feature-background {
    background-color: #ecfafb;
    border-radius: 6px;
    position: absolute;
    left: -30px;
    right: -30px;
    top: 38px;
    bottom: 35px;
  }
  .home-feature-content {
    position: relative;
    z-index: 2;
    padding-bottom: 54px;
    padding-left: 20px;
    padding-right: 20px;
    background: #ffffff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.06);
    border-radius: 6.4px;
    .semi-circle {
      display: block;
      background: #ecfafb;
      position: absolute;
      z-index: 3;
      left: -23px;
      top: 50%;
      margin-top: -23px;
      width: 46px;
      height: 46px;
      border-radius: 50%;
      box-shadow: inset 0 0 10px 0 rgba(0, 0, 0, 0.06);
      &:after {
        content: "";
        position: absolute;
        width: 46px;
        height: 46px;
        left: -5px;
        top: 50%;
        margin-top: -23px;
        border-radius: 50%;
        background-color: #ecfafb;
      }
    }
    .semi-circle-end {
      left: auto;
      right: -23px;
      &:after {
        content: "";
        left: auto;
        right: -5px;
      }
    }
  }
  .home-feature-list {
    .semi-circle {
      display: none;
    }
  }
  .home-feature-main-title {
    font-size: 24px;
    color: $font-color-primary;
    text-align: center;
    font-weight: 500;
    padding: 54px;
    padding-bottom: 50px;
    &.h5 {
      display: none;
    }
  }
  .home-feature-item {
    float: left;
    width: 200px;
    text-align: center;
    position: relative;
    .home-content {
      text-align: left;
      margin-left: 18px;
      margin-right: 18px;
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
    &:after {
      content: "";
      position: absolute;
      top: 100px;
      height: 40px;
      border-right: 1px solid rgba(0, 0, 0, 0.12);
      right: 0;
    }
  }
  .home-feature-icon {
    width: 137px;
    height: 90px;
  }
  .home-feature-title {
    font-size: 18px;
    line-height: 25px;
    font-weight: 500;
    color: $font-color-primary;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .home-partner-wrapper {
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .home-partner-title {
    font-weight: 500;
    padding-top: 100px;
    padding-bottom: 20px;
    font-size: 24px;
    color: $font-color-primary;
  }
  .home-partner-sub-title {
    font-size: 18px;
    padding-bottom: 50px;
  }
  .home-partner-list {
    overflow: hidden;
    padding-bottom: 100px;
  }
  .home-partner-img {
    display: none;
  }
  .home-partner-item {
    float: left;
    margin-left: 110px;
    &:first-child {
      margin-left: 0;
    }
    img {
      width: 64px;
      height: 64px;
      margin: 20px;
    }
    p {
      font-size: 18px;
      color: $font-color-primary;
    }
  }
  .home-contact-wrapper {
    display: flex;
    justify-content: center;
  }
  .home-contact {
    padding-bottom: 60px;
    padding-left: 145px;
    padding-right: 145px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
  }
  .home-contact-title {
    text-align: center;
    padding-top: 40px;
    padding-bottom: 50px;
    font-size: 24px;
    font-weight: 500;
    color: $font-color-primary;
  }
  .home-contact-content {
    display: flex;
  }
  .home-contact-item {
    &--right {
      padding-left: 145px;
    }
    &--left {
      position: relative;
      &-p1{
        font-size:20px;
        margin-bottom:10px;
        color:#000;
        font-weight: normal;
        margin-top:9px;
      }
      &-p2{
        font-size:16px;
        color:rgba(0,0,0,.54);
        font-weight: normal;
        margin-bottom:50px;
      }
    }
    .error-text {
      position: absolute;
      top: 83px;
      font-size: 18px;
      left: 0;
    }
    h1 {
      font-size: 24px;
      color: $font-color-primary;
      font-weight: normal;
    }
    h2 {
      font-size: 18px;
      padding-top: 8px;
      font-weight: normal;
    }
  }
  .home-contact-form {
    padding-top: 50px;
  }
  .home-contact-qr {
    text-align: center;
    img {
      padding-top: 50px;
      padding-bottom: 50px;
    }
  }
  .city-select-form-item {
    position: relative;
  }
  .city-select {
    position: absolute;
    top: 43px;
    left: 0;
    right: 0;
    display: flex;
  }
  .city-select-list {
    flex: 1;
    border-radius: 4px;
    min-width: 160px;
    background-color: #fff;
    max-height: 200px;
    overflow: auto;
    box-shadow: 1px 1px 13px rgba(0, 0, 0, 0.1);
  }
  .city-select-item {
    font-size: 14px;
    padding: 0 20px;
    height: 34px;
    line-height: 34px;
    box-sizing: border-box;
    &:hover,
    &.active {
      background-color: #f5f7fa;
    }
    &.active {
      color: $green;
    }
  }
  .error-text {
    color: $red;
  }
}
@media screen and (max-width: 500px) {
  #home {
    .app-header {
      position: static;
      height: 60px;
    }
    .app-header-nav {
      justify-content: center;
      max-width: auto;
      height: 60px;
    }
    .app-header-button {
      display: block;
    }
    .app-header-nav-box {
      display: none;
    }
    .home-banner-wrapper {
      margin-top: 0;
    }
    .home-arrow-line-left {
      border-width: 0 15px 15px 15px;
    }
    .home-arrow-line-right {
      border-width: 0 15px 15px 15px;
    }
    .home-intro-title {
      font-size: 28px;
    }
    .home-main-item {
      padding-bottom: 0;
    }
    .home-content-h5-wrap {
      padding-top: 15px;
      display: block;
      .home-content {
        display: block;
        margin-left: 30px;
      }
    }
    .home-content {
      display: none;
    }
    .home-feature-wrapper {
      display: block;
      padding: 0;
      padding-top: 25px;
    }
    .home-feature-background {
      display: none;
    }
    .home-feature-content {
      padding-bottom: 40px;
      background: none;
      box-shadow: none;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      position: static;
      .semi-circle {
        display: none;
      }
    }
    .home-feature-main-title {
      display: none;
      &.h5 {
        display: block;
        padding-top: 0;
        padding-bottom: 24px;
        font-size: 18px;
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -90px;
      }
    }
    .home-feature-list {
      width: 1120px;
      padding-top: 45px;
      .semi-circle {
        display: block;
        width: 20px;
        height: 20px;
        top: 60px;
        left: -10px;
        margin-top: 0;
        background-color: #cbf3f5;
        &:after {
          top: 0;
          width: 20px;
          height: 20px;
          left: -5px;
          margin-top: 0;
          background-color: #cbf3f5;
        }
      }
      .semi-circle-end {
        left: auto;
        right: -10px;
        &:after {
          left: auto;
          right: -5px;
        }
      }
    }
    .home-feature-item {
      background-color: #fff;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.06);
      border-radius: 6.4px;
      height: 291px;
      margin-left: 24px;
      &:after {
        display: none;
      }
      &:first-child {
        margin-left: 0;
      }
      img {
        padding-top: 24px;
      }
      .home-feature-title {
        padding-top: 16px;
        padding-bottom: 4px;
      }
      .home-content {
        display: block;
        font-size: 13px;
        padding-top: 6px;
      }
    }
    .home-intro {
      position: static;
      text-align: center;
    }
    .home-intro-icon {
      margin-top: 4px;
      justify-content: center;
    }
    .home-pic {
      float: none !important;
      padding: 0 30px;
      padding-top: 40px;
      img {
        width: 100%;
      }
    }
    .home-partner-title {
      font-size: 18px;
      padding-top: 50px;
      padding-bottom: 0;
    }
    .home-partner-sub-title {
      padding-top: 8px;
      padding-bottom: 40px;
      font-size: 14px;
    }
    .home-partner-list {
      display: none;
    }
    .home-partner-img {
      display: block;
      padding: 0 20px;
      padding-bottom: 50px;
      img {
        width: 100%;
      }
    }
    .home-contact-wrapper {
      display: block;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 0;
    }
    .home-contact {
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 26px;
    }
    .home-contact-title {
      font-size: 18px;
      padding-top: 20px;
      padding-bottom: 8px;
    }
    .home-contact-content {
      display: block;
    }
    .home-contact-item {
      h1 {
        display: none;
      }
      h2 {
        font-size: 14px;
      }
      .home-contact-form {
        padding-top: 24px;
      }
      .home-contact-form-submit-button {
        display: flex;
        justify-content: center;
      }
      .error-text {
        font-size: 14px;
        top: 29px;
      }
    }
    .home-contact-qr {
      img {
        padding-top: 0;
        padding-bottom: 24px;
      }
      p {
        color: $primaryColor;
      }
      .dn {
        display: block;
      }
    }
    .home-contact-item--right {
      padding-left: 0;
      padding-top: 60px;
      h2 {
        display: none;
      }
    }
    .home-banner {
      height: auto;
    }
    .home-banner-item {
      display: none;
    }
    .home-banner-mobile {
      display: block;
      position: relative;
      .app-button {
        position: absolute;
        border-radius: 18px;
        padding-left: 32px;
        padding-right: 32px;
        bottom: 35px;
        left: 50%;
        margin-left: -60px;
      }
    }
  }
  .app-footer {
    font-size: 12px;
    padding-top: 33px;
    padding-bottom: 16px;
  }
}
</style>
